import { PrismicRichText } from "@prismicio/react";
import { useState, useRef } from "react";
import { Icon } from "@/components";
import Styles from "./Accordion.module.css";
/**
 * @typedef {import("@prismicio/client").Content.AccordionSlice} AccordionSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<AccordionSlice>} AccordionProps
 * @param {AccordionProps}
 */
const Accordion = ({ slice: { primary, items } }) => {
	const [active, setActive] = useState();
	const accordion = useRef();

	const handleClick = (event, index) => {
		const panel = event.currentTarget.nextSibling;
		const allPanels = accordion?.current.querySelectorAll("div[panel='true']");
		// If click on active close that panel and return
		if (active == index) {
			panel.style.maxHeight = 0;
			setActive(null);
			return;
		}
		// close all panels then open clicked panel and set as active
		allPanels.forEach((item) => {
			item.style.maxHeight = 0;
		});
		panel.style.maxHeight = panel.scrollHeight + 40 + "px";
		setActive(index);
	};

	return (
		<section className={Styles.wrapper}>
			<div className={Styles.container} data-contain="true">
				<h2 className={Styles.heading}>{primary?.heading}</h2>
				<div className={Styles.accordion} ref={accordion}>
					{items.map((item, index) => (
						<div
							key={index}
							className={Styles.accordionItem}
							data-active={active == index}
						>
							<button
								onClick={(event) => handleClick(event, index)}
								className={Styles.accordionBtn}
							>
								{active !== index ? (
									<Icon icon="Plus" size={24} />
								) : (
									<Icon icon="Minus" size={24} />
								)}
								<h5 className={Styles.title}>{item.title}</h5>
							</button>
							<div className={Styles.accordionPanel} panel="true">
								<PrismicRichText field={item?.content} />
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Accordion;
